import axios from 'axios';
import React, { useEffect } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { alertRef } from '../../App';
import './Sidebar.scss';

const menuRouteName = {
    'store': '매장현황',
    'sms': '문자관리',
    'order': '오더관리',
    'tablet': '테이블 오더',
    'pickup': '픽업 오더',
    'hotel': '호텔 오더',
    'waiting': '웨이팅 관리',
    'customer':'고객 정보',
    'coupon': '쿠폰관리',
    'history': '내역',
    'jungsan': '정산',
    'vat': '부가세 신고자료',
    'setting': '태블릿 설정'
}

const SideBar = (props) => {
    const [select, setSelect] = React.useState('store')//선택된 메뉴
    const [isShow, setIsShow] = React.useState(true)//사이드바 유무
    const [isHide, setIsHide] = React.useState(true)//

    useEffect(() => {
        if (window.innerWidth < 1421) {
            setIsShow(false)
            setIsHide(true)
        } else {
            setIsShow(true)
            setIsHide(false)
        }
        window.addEventListener('resize', (e) => {
            if (window.innerWidth < 1421) {
                setIsHide(true)
                setIsShow(false)
            }
            else {
                setIsHide(false)
                setIsShow(true)
            }
        })
    }, [])

    const navigate = useNavigate();

    const handleMenu = (id) => {
        setSelect(id)
    }

    const toggleSidebar = () => {
        if (isHide) setIsShow(old => !old);
    }

    const logout = () => {
        axios.delete('/api/session')
            .then((data) => {
                localStorage.removeItem('storeName')
                navigate('/login')
            })
    }

    return (
        <div className='sidebar-wrapper'>
            <div onClick={() => toggleSidebar()} className="menu-icon-box" style={{ height: isHide ? 'auto' : 0 }}>
                <img className='menu-icon' src={require('../../aseets/icons/sidebar-menu.svg').default} />
                <p className='route-name'>{menuRouteName[select]}</p>
            </div>
            {
                isShow &&
                <div className='side-back' onClick={() => toggleSidebar()}></div>
            }
            <div className='sidebar' style={{ width: isShow ? 325 : 0, paddingLeft: isShow ? 16 : 0, paddingRight: isShow ? 16 : 0, opacity: isShow ? 1 : 0 }}>
                <p className='logo'>SYRUP FRIENDS</p>

                <NavLink to={'/stats'} onClick={() => toggleSidebar()}>
                    <div className='menu' style={{ paddingLeft: 64 }} onClick={() => setSelect('store')}>
                        <img src={require('../../aseets/icons/menu_store.svg').default} style={{ width: 24, height: 24, marginRight: 16 }} />매장현황
                    </div>
                </NavLink>

                <div className='menu' style={{ paddingLeft: 32 }} onClick={() => handleMenu('sms')}>
                    <img className={select === 'sms' ? 'rotate' : 'rotate-not'} src={require('../../aseets/icons/menu_arrow.svg').default} style={{ width: 24, height: 24, marginRight: 8 }} />
                    <img src={require('../../aseets/icons/menu_sms.svg').default} style={{ width: 24, height: 24, marginRight: 16 }} />
                    문자
                </div>
                <div id="sms" className='child-menu' style={{ display: select === 'sms' ? 'flex' : 'none' }}>
                    <NavLink to={'/target-sms/visit'} onClick={() => { toggleSidebar(); handleMenu('sms'); }}>
                        <p className='child-menu-text'>타겟문자 설정</p>
                    </NavLink>
                    <NavLink to={'/all-sms'} onClick={() => { toggleSidebar(); handleMenu('sms') }}>
                        <p className='child-menu-text'>전체문자 발송</p>
                    </NavLink>
                    <NavLink to={'/auto-sms/first'} onClick={() => { toggleSidebar(); handleMenu('sms'); }}>
                        <p className='child-menu-text'>자동문자 설정</p>
                    </NavLink>
                </div>

                <div className='menu' style={{ paddingLeft: 32 }} onClick={() => handleMenu('order')}>
                    <img className={select === 'order' ? 'rotate' : 'rotate-not'} src={require('../../aseets/icons/menu_arrow.svg').default} style={{ width: 24, height: 24, marginRight: 8 }} />
                    <img src={require('../../aseets/icons/menu_order.svg').default} style={{ width: 24, height: 24, marginRight: 16 }} />
                    오더
                </div>
                <div id="sms" className='child-menu' style={{ display: select === 'order' ? 'flex' : 'none' }}>
                    <NavLink to={'/order/store/store-info'} onClick={() => { toggleSidebar(); handleMenu('order') }}>
                        <p className='child-menu-text'>매장 정보</p>
                    </NavLink>
                    <NavLink to={'/delivery/area'} onClick={() => { toggleSidebar(); handleMenu('order') }}>
                        <p className='child-menu-text'>배달 설정</p>
                    </NavLink>
                    <NavLink to={'/order/menu'} onClick={() => { toggleSidebar(); handleMenu('order'); }}>
                        <p className='child-menu-text'>메뉴 관리</p>
                    </NavLink>
                </div>

                <NavLink to={'/tablet-order/info'}>
                    <div className='menu' style={{ paddingLeft: 64 }} onClick={() => { handleMenu('tablet'); toggleSidebar(); }}>
                        <img src={require('../../aseets/icons/tablet-landscape.svg').default} style={{ width: 26, height: 26, marginRight: 14 }} />
                        테이블 오더
                    </div>
                </NavLink>

                <NavLink to={'/pickup-order/info'}>
                    <div className='menu' style={{ paddingLeft: 64 }} onClick={() => { handleMenu('tablet'); toggleSidebar(); }}>
                        <img src={require('../../aseets/icons/pickup-order.svg').default} style={{ width: 26, height: 26, marginRight: 14 }} />
                        픽업 오더
                    </div>
                </NavLink>

                <NavLink to={'/hotel-order/info'}>
                    <div className='menu' style={{ paddingLeft: 64 }} onClick={() => { handleMenu('tablet'); toggleSidebar(); }}>
                        <img src={require('../../aseets/icons/hotel-oder.svg').default} style={{ width: 26, height: 26, marginRight: 14 }} />
                        호텔 오더
                    </div>
                </NavLink>

                <NavLink to={'/waiting'}>
                    <div className='menu' style={{ paddingLeft: 64 }} onClick={() => { handleMenu('waiting'); toggleSidebar(); }}>
                        <img src={require('../../aseets/icons/waiting-menu.svg').default} style={{ width: 24, height: 24, marginRight: 16 }} />
                        웨이팅 관리
                    </div>
                </NavLink>

                <NavLink to={'/customer/customer-list'}>
                    <div className='menu' style={{ paddingLeft: 64 }} onClick={() => { handleMenu('customer'); toggleSidebar(); }}>
                        <img src={require('../../aseets/icons/user.svg').default} style={{ width: 24, height: 24, marginRight: 16 }} />
                        고객 정보
                    </div>
                </NavLink>

                <div className='menu' style={{ paddingLeft: 32 }} onClick={() => handleMenu('coupon')}>
                    <img className={select === 'coupon' ? 'rotate' : 'rotate-not'} src={require('../../aseets/icons/menu_arrow.svg').default} style={{ width: 24, height: 24, marginRight: 8 }} />
                    <img src={require('../../aseets/icons/menu_coupon.svg').default} style={{ width: 24, height: 24, marginRight: 16 }} />
                    쿠폰
                </div>
                <div id="coupon" className='child-menu' style={{ display: select === 'coupon' ? 'flex' : 'none' }}>
                    <NavLink to={'/coupon'} onClick={() => { toggleSidebar(); handleMenu('coupon') }}>
                        <p className='child-menu-text'>매장 쿠폰</p>
                    </NavLink>
                    <NavLink to={'/commerce-coupon'} onClick={() => { toggleSidebar(); handleMenu('coupon') }}>
                        <p className='child-menu-text'>커머스 쿠폰</p>
                    </NavLink>
                </div>

                <NavLink to={'/history/order-history'}>
                    <div className='menu' style={{ paddingLeft: 64 }} onClick={() => { handleMenu('history'); toggleSidebar(); }}>
                        <img src={require('../../aseets/icons/menu_history.svg').default} style={{ width: 24, height: 24, marginRight: 16 }} />
                        내역
                    </div>
                </NavLink>

                <NavLink to={'/jungsan'}>
                    <div className='menu' style={{ paddingLeft: 64 }} onClick={() => { handleMenu('jungsan'); toggleSidebar(); }}>
                        <img src={require('../../aseets/icons/menu_jungsan.svg').default} style={{ width: 24, height: 24, marginRight: 16 }} />
                        정산
                    </div>
                </NavLink>

                <NavLink to={'/vat'}>
                    <div className='menu' style={{ paddingLeft: 64 }} onClick={() => { handleMenu('vat'); toggleSidebar() }}>
                        <img src={require('../../aseets/icons/menu_vat.svg').default} style={{ width: 24, height: 24, marginRight: 16 }} />
                        부가세 신고자료
                    </div>
                </NavLink>

                <NavLink to={'/setting'}>
                    <div className='menu' style={{ paddingLeft: 64 }} onClick={() => { handleMenu('setting'); toggleSidebar() }}>
                        <img src={require('../../aseets/icons/setting.svg').default} style={{ width: 24, height: 24, marginRight: 16 }} />
                        설정
                    </div>
                </NavLink>

                <p className='logout' onClick={() => alertRef.current.showAlert({ title: `로그아웃 하시겠습니까?`, isConfirm: true, confirmText: '로그아웃', isCancel: true, cancelText: '취소', onConfirm: () => { alertRef.current.hideAlert(); logout(); } })}>로그아웃</p>
            </div>
        </div>
    )
}

export default SideBar;